import React from 'react';
import SignUpForm from '../../Features/SignUpForm/SignUpForm';
import Terms from '../../../../Features/Terms/Terms';
import SocialLinks from '../../../../Features/SocialLinks/SocialLinks';
import styles from './SignUpMainFormStepMobile.module.scss';
import { useTranslation } from 'react-i18next';
import LayoutMobileBackHeader from '../../../../../Common/Mobile/Layout/BackHeader/LayoutMobileBackHeader';
import ProgressLine from '../../../../../Common/ProgressLine/ProgressLine';
import AuthBetweenLink from '../../../../Features/AuthBetweenLink/AuthBetweenLink';
import { SIGN_UP_STEPS_COUNT } from '../../../../../../common/constants';

function SignUpMainFormStepMobile() {
  const { t } = useTranslation();
  return (
    <LayoutMobileBackHeader
      header={<ProgressLine step={1} count={SIGN_UP_STEPS_COUNT}/>}
    >
      <div className={styles.container}>
        <div className={styles.subtitle}>
          <span className={styles.subtitleColored}>{t('signup.intro.subtitle1')}</span>&nbsp;<span>{t('signup.intro.subtitle2')}</span>
        </div>
        <span className={styles.title}>{t('signup.intro.title')}</span>
        <SignUpForm/>
        <Terms/>
        <SocialLinks additionalText={t('signup.social.additional.text')}/>
        <AuthBetweenLink title={t('signup.main.login1')} link={'/auth/login'} linkText={t('signup.main.login2')}/>
      </div>
    </LayoutMobileBackHeader>
  )
}

export default SignUpMainFormStepMobile;